import { ChildComponentProps } from '../../mainwrappercomponent';
import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { CreateAccountViewImpl } from './createaccountview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { CreateAccountCSSStyleImpl } from './createaccountcss';
import { RoutingFeatures } from '../../navigation/routingfeature';
import { CreateAccountAPIModelImpl, CreateAccountAPIModel } from './createaccountapimodel';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { CategoryDto } from '../../../../core/dto/categories/categorydto';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { CreateAccountDto } from 'src/com/sixdee/crbtportal/core/dto/createaccount/createaccountdto';


export interface CreateAccountComponentProps extends ChildComponentProps
{

}

export interface CreateAccountComponentState extends UIComponentState
{
   isOtpSuccess: boolean;
   sectoken: string;
   msisdn: string;
}
export interface CreateAccountComponentHandler extends UIComponentHandler
{
    onSignUpClick(): void;
    onSignUp():void;
    onLoginButtonClick(): void;
    onLogoClicked(): void;
}

export class CreateAccountComponent extends UIComponentImpl<CreateAccountComponentProps, CreateAccountComponentState, UIDataModel>
{
    constructor(props: CreateAccountComponentProps)
    {
        super(props);

        this.state = {isOtpSuccess: false, sectoken: "", msisdn: ""};
    }

    componentDidMount()
    {
        if(this.props.context.getUserContext().getIsLoggedIn())
        {
            this.props.context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, true);
        }
        else
        {
            this.getAPIModel().getCategories();
        }
    }

    componentWillReceiveProps()
    {
        this.state = {isOtpSuccess: false, sectoken: "", msisdn: ""};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new CreateAccountViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new CreateAccountCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new CreateAccountAPIModelImpl(applicationContext, apiModelHandler);
    }
    onLogoClicked(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.HOME, false);
    }
    onLoginButtonClick(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.LOGIN, false);
    }

    onSignUp():void
    {
            (this.getView() as CreateAccountViewImpl).showLoader();
            this.getAPIModel().validateNumber((this.getView() as CreateAccountViewImpl).getData());
     }

    onSignUpClick(): void 
    {
      (this.getView() as  CreateAccountViewImpl).validateData();
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as CreateAccountViewImpl).dismissLoader();
        if(feature === APIFeatures.CREATE_ACCOUNT)
        {
            this.setState({isOtpSuccess: true, 
                msisdn: (this.getView() as CreateAccountViewImpl).getData().getMsisdn(), 
                sectoken :  (data as CreateAccountDto).getSecToc()});
            // this.props.routeNextFeature(RoutingFeatures.CREATE_ACCOUNT_OTP_MESSAGE, false);
        }
        else if(feature === APIFeatures.SIGNUP_CATEGORIES)
        {
            (this.getView() as CreateAccountViewImpl).updateCategoriesData(data as CategoryDto[]);
        }
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as CreateAccountViewImpl).dismissLoader();
    (this.getView() as CreateAccountViewImpl).showPopup("",description,AlertType.ERROR);

    }

    getAPIModel(): CreateAccountAPIModel {
        return super.getAPIModel() as CreateAccountAPIModel;
    }
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/createaccountcomponent.tsx